import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";

type MedicationLegendProps = ComponentPropsWithoutRef<"div">;

const MedicationLegend = ({ className, ...otherProps }: MedicationLegendProps) => (
  <div className={cn("flex w-fit items-center gap-4 text-sm", className)} {...otherProps}>
    <div className="flex w-fit items-center gap-1">
      <PillIcon iconName="pill" />
      <span>
        Patient reported <span className="font-semibold">med taken</span>
      </span>
    </div>
    <div className="flex w-fit items-center gap-1">
      <PillIcon iconName="pill_off" />
      <span>
        Patient reported <span className="font-semibold">med not taken</span>
      </span>
    </div>
  </div>
);

type PillIconProps = { iconName: "pill" | "pill_off" };

const PillIcon = ({ iconName }: PillIconProps) => (
  <span className="material-symbols-outlined text-gray-400" style={{ fontSize: "18px" }}>
    {iconName}
  </span>
);

export default MedicationLegend;
